// extracted by mini-css-extract-plugin
export default {"authorityLinkSpinner":"authorityLinkSpinner---mAzqJ"};